import { css } from '@emotion/react'

const base = css`
  & > * {
    max-width: 100% !important;
  }
`

const search = css`
  width: 100%;
`

export const styles = { base, search }
